import { GroupChatFormFields } from "@/pages/Groupchat/types";
import { handleCheckIfTagsAreEqual } from "@/utils/handleCheckIfTagsAreEqual";

type GroupFormContentValues = Record<string, unknown>;

const KEYS_TO_EXCLUDE = [GroupChatFormFields.GUIDELINES];

const isEmptyFormValue = (value: unknown): boolean => value === null || value === undefined || value === "";

const areMembersEqual = (currentMembers: { id: string }[], initialMembers: { id: string }[]): boolean => {
  if (currentMembers.length !== initialMembers.length) {
    return false;
  }

  if (!currentMembers.length && !initialMembers.length) {
    return true;
  }

  const currentIds = new Set(currentMembers.map((member) => member.id));
  const initialIds = new Set(initialMembers.map((member) => member.id));

  return currentIds.size === initialIds.size && [...currentIds].every((memberId) => initialIds.has(memberId));
};

const hasGroupFormContentChanged = ({
  currentValues,
  referenceValues,
}: {
  currentValues: GroupFormContentValues;
  referenceValues: GroupFormContentValues | null | undefined;
}): boolean => {
  if (!referenceValues || Object.keys(referenceValues).length === 0) {
    return false;
  }

  const allKeys = new Set([...Object.keys(currentValues || {}), ...Object.keys(referenceValues)]);

  return Array.from(allKeys).some((key: string) => {
    if (KEYS_TO_EXCLUDE.includes(key as GroupChatFormFields)) {
      return false;
    }

    const currentValue = currentValues[key];
    const referenceValue = referenceValues[key];

    if (isEmptyFormValue(currentValue) && isEmptyFormValue(referenceValue)) {
      return false;
    }

    if (key === GroupChatFormFields.TAGS) {
      const currentTags = (currentValue as string[]) || [];
      const referenceTags = (referenceValue as string[]) || [];
      return !handleCheckIfTagsAreEqual(currentTags, referenceTags);
    }

    if (key === GroupChatFormFields.MEMBERS) {
      const currentMembers = (currentValue as { id: string }[]) || [];
      const referenceMembers = (referenceValue as { id: string }[]) || [];
      return !areMembersEqual(currentMembers, referenceMembers);
    }

    return JSON.stringify(currentValue) !== JSON.stringify(referenceValue);
  });
};

export default hasGroupFormContentChanged;
